import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import { Focusable, FocusableParent } from 'components/navigation';

export const StyledBackdrop = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.45);
  z-index: 2;
  left: 0;
  top: 0;
`;

export const StyledPanel = styled(FocusableParent)`
  width: ${scaleSize(580)}px;
  min-height: 100%;
  box-sizing: border-box;
  background: ${({ theme }) => theme.backgroundColor};
  border-right: solid 2px ${({ theme }) => theme.submenuActiveColor};
  z-index: 2;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  text-align: right;
  transform: translate3d(0, ${({ offset }) => offset}px, 0);
`;

export const StyledTitle = styled.div`
  margin-left: ${scaleSize(30)}px;
  margin-top: ${scaleSize(80)}px;
  font-size: ${scaleSize(68)}px;
  color: ${({ theme }) => theme.defaultColor};
  text-align: left;
`;

export const StyledList = styled.div`
  position: absolute;
  top: ${scaleSize(260)}px;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  height: ${scaleSize(820)}px;
  overflow: hidden;
`;

export const StyledRow = styled.div`
  display: table-row;
`;

export const StyledFilterName = styled.div`
  display: table-cell;
`;

export const StyledFilterValues = styled.div`
  display: table-cell;
  width: 100%;
  text-align: right;
  color: ${({ theme }) => theme.mainTextColor};
`;

export const StyledListItem = styled(Focusable)`
  width: ${scaleSize(570)}px;
  height: ${scaleSize(80)}px;
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px 0 0 ${scaleSize(12)}px;
  line-height: ${scaleSize(80)}px;
  display: block;
  color: ${({ theme, isActive }) => (isActive ? theme.activeColor : theme.defaultColor)};
  text-align: left;
  padding: 0 ${scaleSize(30)}px;
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(30)}px;
  letter-spacing: ${scaleSize(-0.21)}px;
  margin-bottom: ${scaleSize(20)}px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &:focus {
    color: ${({ theme }) => theme.defaultColor};
    background-color: ${({ theme }) => theme.activeColor};

    & ${StyledFilterValues} {
      color: ${({ theme }) => theme.defaultColor};

      svg path {
        fill: ${({ theme }) => theme.defaultColor};
      }
    }
  }
`;

export const StyledClearButtom = styled(StyledListItem)`
  display: ${({ disabled }) => (disabled ? 'none' : 'block')};
  width: ${scaleSize(560)}px;
  position: absolute;
  left: ${scaleSize(10)}px;
  text-align: center;
  bottom: ${scaleSize(10)}px;
  border-radius: ${scaleSize(12)}px;
  background-color: ${({ theme }) => theme.submenuActiveColor};
`;

export const StyledLeftBarIcon = styled(Focusable)`
  display: block;
  position: absolute;
  width: ${scaleSize(1280)}px;
  height: ${scaleSize(100)}px;
  left: -${({ isMenuVisible }) => scaleSize(isMenuVisible ? 609 : 709)}px;
  top: ${scaleSize(490)}px;
  transform: rotate(-90deg);
  z-index: 3;
  background-color: ${({ theme }) => theme.submenuActiveColor};

  svg {
    height: ${scaleSize(40)}px;
    width: ${scaleSize(40)}px;
    display: block;
    margin: ${({ isMenuVisible }) => scaleSize(isMenuVisible ? 36 : 44)}px auto;
    transform: rotate(90deg);
  }

  &:hover {
    color: ${({ theme }) => theme.defaultColor};
    background-color: ${({ theme }) => theme.activeColor};
  }
`;
